import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  \n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { BUTTON_FONT_SIZE, BUTTON_LINE_HEIGHT, BUTTON_MEDIUM_PADDING, BUTTON_MEDIUM_PADDING_FULL_WIDTH, BUTTON_SMALL_PADDING, BUTTON_SMALL_PADDING_FULL_WIDTH } from './constants';
import { buttonStyle } from './helpers';
import ButtonBaseWithContent from './components/ButtonBaseWithContent';
import { buttonTypographyStyle } from '../Typography/style/button';
import { buttonBorderRadiusStyle } from './style/border-radius';
import { lineHeight } from '../style/line-height';
import { fontSize } from '../style/font-size';
import { padding } from '../style/padding';
var StyledButton = styled(ButtonBaseWithContent)(_templateObject(), buttonTypographyStyle, function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size;
  return fontSize(BUTTON_FONT_SIZE[size] || BUTTON_FONT_SIZE.medium);
}, function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size;
  return lineHeight(BUTTON_LINE_HEIGHT[size] || BUTTON_LINE_HEIGHT.medium);
}, buttonBorderRadiusStyle, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'medium' : _ref3$size,
      fullWidth = _ref3.fullWidth;
  return size === 'small' ? padding(fullWidth ? BUTTON_SMALL_PADDING_FULL_WIDTH : BUTTON_SMALL_PADDING) : padding(fullWidth ? BUTTON_MEDIUM_PADDING_FULL_WIDTH : BUTTON_MEDIUM_PADDING);
});
var Button = /*#__PURE__*/React.forwardRef(function (_ref4, forwardedRef) {
  var as = _ref4.as,
      forwardedAs = _ref4.forwardedAs,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'primary' : _ref4$variant,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 'medium' : _ref4$size,
      _ref4$fullWidth = _ref4.fullWidth,
      fullWidth = _ref4$fullWidth === void 0 ? false : _ref4$fullWidth,
      props = _objectWithoutPropertiesLoose(_ref4, ["as", "forwardedAs", "variant", "size", "fullWidth"]);

  var styleProps = buttonStyle[variant] || buttonStyle.primary;
  return /*#__PURE__*/React.createElement(StyledButton, _extends({}, styleProps, {
    size: size,
    fullWidth: fullWidth,
    forwardedAs: as != null ? as : forwardedAs,
    ref: forwardedRef
  }, props));
});
export default Button;